export default __webpack_public_path__ + "static/media/angle-down.9d0833ec.svg";